import {ColonistOneTimePurchaseType, LobbyImage} from '@colonist/types'
import {StoreProductType, StripeCheckoutTypes, BaseColonistStoreProduct} from './BaseColonistStoreProduct'
import {TranslationObject} from '@colonist/i18n'

export class ColonistOneTimePurchaseProduct implements BaseColonistStoreProduct {
    readonly storeProductType: StoreProductType = StoreProductType.OneTimePurchase
    readonly type: ColonistOneTimePurchaseType

    readonly title: TranslationObject
    readonly lobbyImage: LobbyImage

    readonly stripePriceId: string
    readonly stripeCheckoutType: StripeCheckoutTypes = StripeCheckoutTypes.Payment

    readonly discordSKUId: string

    readonly price: number
    itemQuantity: number = 1

    readonly isActive: () => boolean

    constructor(source: Pick<ColonistOneTimePurchaseProduct, 'type' | 'title' | 'price' | 'stripePriceId' | 'discordSKUId' | 'lobbyImage' | 'isActive'>) {
        Object.assign(this, source)
    }

    getProductName(): TranslationObject {
        return this.title
    }
    getDefaultPrice(): string {
        return `$${this.price / 100}`
    }

    getUSDPrice(): number {
        return this.price / 100
    }

    private static readonly products = new Map<ColonistOneTimePurchaseType, ColonistOneTimePurchaseProduct>()

    static getOneTimePurchaseProduct(oneTimePurchaseType: ColonistOneTimePurchaseType, itemQuantity: number = 1): ColonistOneTimePurchaseProduct {
        const product = this.products.get(oneTimePurchaseType) as ColonistOneTimePurchaseProduct
        product.itemQuantity = itemQuantity
        return product
    }

    static initProducts(stripePriceIds: Record<string, string>, discordSKUIds: Record<string, string>) {
        this.products.set(ColonistOneTimePurchaseType.Holiday2023AllAccessPass, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.Holiday2023AllAccessPass,
            title: {key: 'strings:storePage.sections.holiday_sale.title', options: {context: 'full'}},
            price: 699,
            stripePriceId: stripePriceIds.passAllAccessHoliday2023,
            discordSKUId: discordSKUIds.passAllAccessHoliday2023,
            lobbyImage: LobbyImage.StoreMembershipHoliday2023,
            isActive: () => false,
        }))
        this.products.set(ColonistOneTimePurchaseType.GiftPlusMonthly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPlusMonthly,
            title: {key: 'strings:storePage.membership.title.plus'},
            price: 899,
            stripePriceId: stripePriceIds.giftMembershipPlus,
            discordSKUId: discordSKUIds.giftMembershipPlus,
            lobbyImage: LobbyImage.StoreMembershipPlus,
            isActive: () => true,
        }))
        this.products.set(ColonistOneTimePurchaseType.GiftPremiumMonthly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPremiumMonthly,
            title: {key: 'strings:storePage.membership.title.premium'},
            price: 1899,
            stripePriceId: stripePriceIds.giftMembershipPremium,
            discordSKUId: discordSKUIds.giftMembershipPremium,
            lobbyImage: LobbyImage.StoreMembershipPremium,
            isActive: () => true,
        }))
        this.products.set(ColonistOneTimePurchaseType.GiftEliteMonthly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftEliteMonthly,
            title: {key: 'strings:storePage.membership.title.elite'},
            price: 2499,
            stripePriceId: stripePriceIds.giftMembershipElite,
            discordSKUId: discordSKUIds.giftMembershipElite,
            lobbyImage: LobbyImage.StoreMembershipElite,
            isActive: () => true,
        }))
        this.products.set(ColonistOneTimePurchaseType.GiftPlusYearly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPlusYearly,
            title: {key: 'strings:storePage.membership.title.plus'},
            price: 8388,
            stripePriceId: stripePriceIds.giftMembershipPlusYearly,
            discordSKUId: discordSKUIds.giftMembershipPlusYearly,
            lobbyImage: LobbyImage.StoreMembershipPlus,
            isActive: () => true,
        }))
        this.products.set(ColonistOneTimePurchaseType.GiftPremiumYearly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftPremiumYearly,
            title: {key: 'strings:storePage.membership.title.premium'},
            price: 17988,
            stripePriceId: stripePriceIds.giftMembershipPremiumYearly,
            discordSKUId: discordSKUIds.giftMembershipPremiumYearly,
            lobbyImage: LobbyImage.StoreMembershipPremium,
            isActive: () => true,
        }))
        this.products.set(ColonistOneTimePurchaseType.GiftEliteYearly, new ColonistOneTimePurchaseProduct({
            type: ColonistOneTimePurchaseType.GiftEliteYearly,
            title: {key: 'strings:storePage.membership.title.elite'},
            price: 23988,
            stripePriceId: stripePriceIds.giftMembershipEliteYearly,
            discordSKUId: discordSKUIds.giftMembershipEliteYearly,
            lobbyImage: LobbyImage.StoreMembershipElite,
            isActive: () => true,
        }))
    }
}
